import RegistrationSuccess from './RegistrationSuccess'
export default RegistrationSuccess